import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "form-group"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Login abilitata (visibile solo ad admin)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_input = _resolveComponent("localized-input")!
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_localized_input, {
      labelKey: "Email di login",
      labelValue: "Email di login",
      placeholderKey: "Email di login",
      placeholderValue: "Email di login",
      modelValue: _ctx.item.username,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.username) = $event)),
      disabled: !_ctx.$store.state.isAdmin()
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("label", {
      class: "text-warning pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPasswordChange && _ctx.showPasswordChange(...args)))
    }, [
      (!_ctx.showPassword)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: "Clicca per modificare la password",
            text: "Clicca per modificare la password"
          }))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            localizedKey: "Annulla",
            text: "Annulla"
          }))
    ]),
    _createVNode(_component_localized_input, {
      type: "password",
      labelKey: "Password",
      labelValue: "Password",
      placeholderKey: "Password",
      placeholderValue: "Password",
      modelValue: _ctx.item.password,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.item.password) = $event)),
      disabled: !_ctx.showPassword
    }, null, 8, ["modelValue", "disabled"]),
    (_ctx.$store.state.isAdmin())
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.item.loginEnabled) = $event)),
            class: "form-control"
          }, null, 512), [
            [_vModelCheckbox, _ctx.item.loginEnabled]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}